import { AxiosPromise } from 'axios';
import { libApiInstance } from '../axios';
import { DigestReport, DigestReportRequest } from './types/ActivityReport';

export function requestActivityReport(
    data: DigestReportRequest,
    signal?: AbortSignal,
): AxiosPromise<DigestReport> {
    return libApiInstance.post(`reports/activityreport`, data, { signal });
}
